var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M160.5 144v18a6.003 6.003 0 0 1-1.757 4.243A6.003 6.003 0 0 1 154.5 168h-18a6.003 6.003 0 0 1-4.243-1.757A6.003 6.003 0 0 1 130.5 162v-18h30Zm-99 0v18a6.002 6.002 0 0 1-6 6h-18a6 6 0 0 1-6-6v-18h30Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M160.5 54h-129v36h129V54Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M31.5 54h129m-129 36h129m0 54h-129V48a17.923 17.923 0 0 1 18-18h93a17.92 17.92 0 0 1 16.65 11.1 17.925 17.925 0 0 1 1.35 6.9v96Zm0 0v18a6.003 6.003 0 0 1-1.757 4.243A6.003 6.003 0 0 1 154.5 168h-18a6.003 6.003 0 0 1-4.243-1.757A6.003 6.003 0 0 1 130.5 162v-18m-69 0v18a6.002 6.002 0 0 1-6 6h-18a6 6 0 0 1-6-6v-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M63 126a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Zm66 0a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/Transport.73063cd76b4436531bb0768fa0817390.svg";
export { ForwardRef as ReactComponent };